
export const UsuarioIput = {
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    correo: "",
    empresa_hotel: "",
    puesto_rol: null,
    pais: "",
    origen: null,
}